export const ServiceSummaryPage = (destinationLang) => {
  return [
    {
      FormKey: "general-public-service",
      Key: "خدمت",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "confer-summary-label-doer",
      Key: "انجام دهنده",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "confer-summary-label-service",
      Key: "خدمت",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "confer-summary-label-patient",
      Key: "بیمار",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "confer-summary-label-print-summary",
      Key: "چاپ خلاصه پرونده",
      DistinitationLanguage: destinationLang,
    },
  ];
};
